/**
 * Custom browser entry (replaces TanStack Start's default `client.tsx`).
 *
 * PAINT FIRST, THEN HYDRATE (M6 performance). The server already sent the
 * complete page. The default entry evaluated React, the router and the app
 * shell as soon as the chunks arrived, which on a fast connection is BEFORE
 * the browser's first frame: the first paint (and so LCP) then waited for
 * script evaluation. This entry is a few hundred bytes: it lets the browser
 * paint the server HTML, then imports and runs the hydration module.
 *
 * The route chunks are still `modulepreload`ed by TanStack Start (low
 * priority), so they download in parallel with the render; only their
 * EXECUTION moves behind the first frame, typically by one frame. Links are
 * plain `<a href>` and work before hydration.
 */
import { afterFirstPaint } from './lib/runtime/after-first-paint'

void afterFirstPaint()
  .then(() => import('./client-hydrate'))
  .then(({ hydrate }) => hydrate())
